import Header from './components/Header';
import Hero from './components/Hero';
import MediaSection from './components/MediaSection';
import FeaturesSection from './components/FeaturesSection';
import RankingSection from './components/RankingSection';
import CommentsSection from './components/CommentsSection';
import CardsSection from './components/CardsSection';
import TopicsSection from './components/TopicsSection';
import CarouselSection from './components/CarouselSection';
import ContactSection from './components/ContactSection';
import AppSection from './components/AppSection';
import IndexSection from './components/IndexSection';
import AboutSection from './components/AboutSection';
import FaqSection from './components/FaqSection';
import UpdatesSection from './components/UpdatesSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <MediaSection />
        <FeaturesSection />
        <RankingSection />
        <CommentsSection />
        <CardsSection />
        <TopicsSection />
        <CarouselSection />
        <ContactSection />
        <AppSection />
        <IndexSection />
        <AboutSection />
        <FaqSection />
        <UpdatesSection />
      </main>
      <Footer />
    </>
  );
}